import { Input, Spin, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import Preview from "../../planning/VisitBoard/TableView/modals/Preview";
import rejectIcon from "../../../../Assets/svg/cancel-remove-cross-close.svg";
import approveIcon from "../../../../Assets/svg/check-validation-sucess.svg";
import markAsCompletedIcon from "../../../../Assets/svg/check-square-form-validation-checkmark-success-box-square-tick.svg";
import ConfirmModal from "../../../components/confirmModal/ConfirmModal";
import Done from "../../../../Assets/svg/done.svg";
import exclamationMark from "../../../../Assets/svg/exclamationMark.svg";
import previewIcon from "./../../../../Assets/svg/table-action-preview.svg";
import RejectModal from "./RejectModal";
import { httpService } from "../../../../services/httpService.service";
import SearchIcon from "./../../../../Assets/svg/searchIcon.svg";
import Edit from "../ReportingList/modals/Edit";
import { useFilePreview } from "../../completed/ReportingList/Download";
import {
  formatDate,
  formatDateAndTime,
} from "../../../../services/helpFunctions/formatDateAndTime";
import FacilityTag from "../../../components/FacilityTag/FacilityTag";
import { REPORTING_DEFAULT_COLUMNS } from "../../../components/SiteVisitColumns/siteVisitColumnOrder";
import { useSiteVisitColumns } from "../../../components/SiteVisitColumns/useSiteVisitColumns";

const SubmittedForApproval = ({ loading, setLoading, setMessage }) => {
  const { previewFiles } = useFilePreview();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);

  const [siteVisitCards, setSiteVisitCards] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [siteVisitToReject, setSiteVisitToReject] = useState(null);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    total: 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPagination((prevPagination) => ({
      ...prevPagination,
      pageNumber: 1,
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);
  const fetchSiteVisits = () => {
    const projectId = localStorage.getItem("currentProjectID");

    const params = {
      ProjectId: projectId,
      Search: debouncedQuery,
      pageSize: pagination.pageSize,
      pageNumber: pagination.pageNumber,
      ApprovalStatus: 1,
    };

    const filteredParams = Object.keys(params).reduce((acc, key) => {
      if (params[key] !== undefined && params[key] !== null) {
        acc[key] = params[key];
      }
      return acc;
    }, {});

    const queryString = new URLSearchParams(filteredParams).toString();

    const apiUrl = `/api/Site/getAllSiteVisits?${queryString}`;
    setLoading(true);
    httpService
      .get(
        apiUrl,
        (res) => {
          setSiteVisitCards(res.data);
          setPagination({
            pageSize: res.metaData.pageSize,
            pageNumber: res.metaData.pageNumber,
            total: res.metaData.totalItemCount,
          });
        },
        (error) => {
          // console.log(error);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSiteVisits();
  }, [pagination.pageNumber, pagination.pageSize, debouncedQuery]);

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.key;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };

  const columns = [
    {
      title: <span className="styledTitle text-nowrap">Approval Status</span>,
      dataIndex: "approvalStatus",
      key: "approvalStatus",
      render: () => {
        return (
          <div className="documentReview">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8px"
              height="8px"
              viewBox="0 0 9 9"
            >
              <circle cx="4.5" cy="4.27344" r="4" fill="#FC9403" />
            </svg>
            <span>Pending</span>
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle">Site Visit Identifier</span>,
      sorter: (a, b) =>
        a.siteVisitIdentifier.localeCompare(b.siteVisitIdentifier),
      dataIndex: "siteVisitIdentifier",
      key: "siteVisitIdentifier",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Site Visit Name</span>,
      sorter: (a, b) => a.name.localeCompare(b.name),
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Facility</span>,
      dataIndex: "facility",
      key: "facility",
      ellipsis: true,
      width: 250,
      sorter: (a, b) =>
        (a.facility?.name || "").localeCompare(b.facility?.name || ""),
      render: (facility) => <FacilityTag facility={facility} />,
    },
    {
      title: <span className="styledTitle">Actual Dates of Visit</span>,
      sorter: (a, b) => {
        const aDate = a.actualDateOfVisit?.[0] || "";
        const bDate = b.actualDateOfVisit?.[0] || "";
        return aDate.localeCompare(bDate);
      },
      dataIndex: "actualDateOfVisit",
      key: "actualDateOfVisit",
      render: (data) =>
        data?.length ? (
          data?.map((date) => (
            <span
              className="styledDataIndex3"
              style={{ display: "block" }}
              key={date.id}
            >
              {date}
            </span>
          ))
        ) : (
          <span className="styledDataIndex3">
            No actual date of visit available
          </span>
        ),
    },
    {
      title: <span className="styledTitle">Location</span>,
      sorter: (a, b) =>
        a.locationDetails?.country.localeCompare(b.locationDetails?.country),
      key: "location",
      dataIndex: "location",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Governate/State</span>,
      dataIndex: "state",
      key: "state",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">IP</span>,
      sorter: (a, b) => a.ip.localeCompare(b.ip),
      dataIndex: "ip",
      key: "ip",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Cluster</span>,
      sorter: (a, b) => a.cluster.localeCompare(b.cluster),
      dataIndex: "cluster",
      key: "cluster",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Virtual</span>,
      sorter: (a, b) => a.virtual.localeCompare(b.virtual),
      dataIndex: "virtual",
      key: "virtual",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Resources</span>,
      sorter: (a, b) =>
        a.resources?.join("").localeCompare(b.resources?.join("")),
      dataIndex: "resources",
      key: "resources",
      render: (resources) => {
        return (
          <div className="resourcesColumn">
            {resources?.map((file, index) => (
              <span
                onClick={(e) => previewFiles(e, file.fileKey, file.id)}
                key={index}
              >
                {file?.fileName}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      width: 120,
      fixed: isLargeScreen && siteVisitCards.length > 0 ? "right" : undefined,

      render: (text, record) => (
        <div className="actionDiv">
          <img
            src={previewIcon}
            onClick={() => handleTogglePreviewModal(record)}
            style={{ cursor: "pointer" }}
          />
          <Tooltip title="Reject">
            <img
              src={rejectIcon}
              style={{ cursor: "pointer" }}
              alt="reject"
              onClick={() => {
                setSiteVisitToReject(record?.key);
                setShowRejectModal(true);
              }}
            />
          </Tooltip>
          <Tooltip title="Approve">
            <img
              src={approveIcon}
              style={{ cursor: "pointer" }}
              alt="approve"
              onClick={() => {
                ConfirmModal(
                  () => handleChangeConfirm(record?.key), // Pass the function as a callback
                  "Warning", // here it goes the title
                  "Confirming this will approve this site visit! This action can not be undone!", // Information
                  "Do you want to continue?", // Question
                  "Yes" // Confirm button text
                );
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleChangeConfirm = (siteVisitId) => {
    if (!siteVisitId) {
      return;
    }

    setLoading(true);
    httpService.put(
      `/api/Site/changeSiteVisitApprovalStatus?SiteVisitId=${siteVisitId}&ApprovalStatus=2`,
      "",
      (res) => {
        const message =
          res?.message || "You have successfully updated site visit files!";
        setMessage({
          trigger: true,
          type: "success",
          icon: Done,
          title: `Site visit updated successfully!`,
          text: message,
        });

        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
        setLoading(false);
        fetchSiteVisits();
      },
      (error) => {
        const errorMessage =
          error?.errors?.[0]?.message ||
          error?.message ||
          "Failed to update this site visit. Please try again later!";

        setMessage({
          trigger: true,
          type: "danger",
          icon: exclamationMark,
          title: "Update Failed",
          text: errorMessage,
        });

        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
        setLoading(false);
      }
    );
  };

  const formatData = (siteVisitCard) => {
    return {
      key: siteVisitCard?.id,
      siteVisitIdentifier: siteVisitCard?.identifier,
      name: siteVisitCard?.name || "N/A",
      actualDateOfVisit: siteVisitCard?.tracking?.siteTrackingVisitDates.map(
        (date) => formatDate(date?.visitDate)
      ),
      ip: siteVisitCard?.ipPlan?.implementingPartner?.name,
      location: siteVisitCard?.locationDetails?.country,
      state:
        siteVisitCard?.locationDetails?.state || "This country has no states.",
      cluster: siteVisitCard?.cluster?.name,
      virtual: siteVisitCard?.isVirtual ? "Yes" : "No",
      resources: siteVisitCard?.siteVisitFiles.filter((item) =>
        [1, 3, 4, 5].includes(item.fileCategory)
      ),

      reportingYear: siteVisitCard?.tracking?.reportingYear,
      reportingMonth: siteVisitCard?.tracking?.reportingMonth,
      trainingDate: siteVisitCard?.tracking?.trainingDate,
      trainingScoreInfo: siteVisitCard?.tracking?.trainingScoreInfo,
      dateOfReport: siteVisitCard?.tracking?.dateOfReport,
      dateOfDebrief: siteVisitCard?.tracking?.dateOfDebrief,
      percentageOfDataCollectionCompleted:
        siteVisitCard?.tracking?.percentageOfDataCollectionCompleted,
      fieldTeamReportingStatus:
        siteVisitCard?.tracking?.fieldTeamReportingStatus,
      trainingIsCompleted: siteVisitCard?.tracking?.trainingIsCompleted,
    };
  };

  const formattedData = siteVisitCards?.map(formatData);

  const {
    columns: visibleColumns,
    columnsBar,
    components: tableComponents,
  } = useSiteVisitColumns({
    tableId: "approveSubmittedForApproval",
    columns: columns,
    defaultKeys: REPORTING_DEFAULT_COLUMNS,
  });

  const onPageChange = (page, pageSize) => {
    setPagination({ ...pagination, pageNumber: page, pageSize: pageSize });
  };

  const handleEdit = () => {
    fetchSiteVisits();

    setShowEditModal(false);
  };
  return (
    <>
      <div className="flagsPage mb-4">
        <span className="tableViewHeaderText">
          Submitted Site Visits for Approval
        </span>
      </div>
      <Preview
        visible={showPreviewModal}
        onClose={handleTogglePreviewModal}
        siteVisitCardId={selectedSiteVisit}
      />
      <div className="filtersWrapper">
        <div className="containerFilters">
          <Input
            onChange={handleSearch}
            placeholder="Search..."
            suffix={<img src={SearchIcon} alt="Search" />}
          />
        </div>
      </div>
      <div
        className="w-100 my-3 d-flex justify-content-start gap-2"
        style={{
          color: "var(--2, #AA1A5F)",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px",
        }}
      >
        {loading ? (
          <Spin className="me-2" size="small" spinning={loading} />
        ) : (
          `Total: ${pagination.total} visits`
        )}
        {columnsBar && <span className="ms-auto">{columnsBar}</span>}
      </div>
      <Table
        components={tableComponents}
        loading={loading}
        // rowSelection={{ ...rowSelection }}
        dataSource={formattedData}
        columns={formattedData?.length > 0 ? visibleColumns : []}
        pagination={{
          ...pagination,
          onChange: onPageChange,
        }}
        className="tableTPM"
        scroll={{ x: "max-content" }}
      />
      <RejectModal
        visible={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        onOk={() => {
          fetchSiteVisits();
        }}
        siteVisitCardId={siteVisitToReject}
        setMessage={setMessage}
      />
    </>
  );
};

export default SubmittedForApproval;
